import * as React   from 'react';
import { Props }    from './types'
import {
  Link as LinkRouter,
  Router
}                   from 'react-router-dom';
import history      from '../../helpers/history';
import './styles.scss';

export const Link = ({
    label,
    color
  }: Props) => {
  return (
    <Router history={history}>
      <LinkRouter to="/">
        <div className={`link ${color || 'black'}`}>
          {label || ''}
        </div>
      </LinkRouter>
    </Router>
  );
};
